import { Link, LinkProps } from "react-router-dom";

export default function UnstyledLink(props: LinkProps) {
  return <Link {...props} style={{ textDecoration: "none", color: "inherit", ...props.style }} />;
}
